import { render, staticRenderFns } from "./graph-legend.vue?vue&type=template&id=42ff1460&scoped=true"
import script from "./graph-legend.vue?vue&type=script&lang=js"
export * from "./graph-legend.vue?vue&type=script&lang=js"
import style0 from "./graph-legend.vue?vue&type=style&index=0&id=42ff1460&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ff1460",
  null
  
)

export default component.exports